import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CratesDataSourceService } from 'src/app/core/data-sources/crates-data-source.service';
import { ErrorService } from '../../core/services/error.service';
import { ExitService } from '../../core/services/exit.service';
import { PaginationService } from '../../core/services/pagination.service';
import { TaskRequestSidenavService } from '../../core/services/task-request-sidenav.service';
import { StockDetailsModalComponent } from '../../modals/stock-details-modal/stock-details-modal.component';
import { Crate } from '../../../models/Crate';
import { StockSortParams } from '../../core/services/stock.service';
import * as moment from 'moment';

@Component({
  selector: 'app-exit',
  templateUrl: './exit.component.html',
  styleUrls: ['./exit.component.scss']
})
export class ExitComponent implements OnInit {
  actualHour = moment().format('HH:mm');
  isModalLoading = false;
  isLoading = false;
  cratesArray: Crate[] = [];
  cratesMap: Map<String, Crate> = new Map();
  appliedFilters = {};
  sortParams: StockSortParams;
  dataSubscription$: Subscription;
  totalProductsCount = 0;
  commentsSubscription$: Subscription;

  constructor(
    public cratesService: CratesDataSourceService,
    private router: Router,
    private errorService: ErrorService,
    private dialog: MatDialog,
    private sidenavService: TaskRequestSidenavService,
    public exitService: ExitService
  ) { }

  ngOnDestroy(): void {
    this.dataSubscription$.unsubscribe();
    this.commentsSubscription$.unsubscribe();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.exitService.init();
    this.getTotalProductsCount();
    this.dataSubscription$ = this.exitService.items$.subscribe((data) => {
      this.cratesMap.clear();
      const newData = [...data];
      for (const d of newData) {
        this.cratesMap.set(d.id, d);
      }
      this.cratesArray = newData;
      this.isLoading = false;
    });
    this.commentsSubscription$ = this.exitService.crateCommentsQty$.subscribe(comments => {
      for (const comment of comments) {
        if (this.cratesMap.has(comment.crateId)) {
          this.cratesMap.get(comment.crateId).commentsQty = comment.commentsQty;
        }
      }
    });
  }

  onFiltersApply(params: { sortParams, filterParams }) {
    this.exitService.currentPage = 1;
    this.appliedFilters = params?.filterParams;
    this.sortParams = params?.sortParams;
    this.update();
  }

  async onRowClick(event) {
    const crate = event.crate;
    const page = event.column === 'messages' ? 2 : 0; // TODO: use enum to validate column name and tab index
    try {
      this.isModalLoading = true;
      const itemDetails = await this.cratesService.getCrateById(crate.id);
      this.dialog.open(StockDetailsModalComponent, {
        panelClass: 'details-modal',
        data: {
          item: crate,
          itemDetails,
          isExit: true,
          page
        },
        autoFocus: false
      }).afterClosed().subscribe(res => {
        if (res?.openPalletInventorySidenav) {
          const data = { type: "PALLET_INVENTORY", crate: res.crate, position: itemDetails.position };
          this.sidenavService.toggle(data);
        } else if (res === 'SUBMITTED') {
          this.update();
        }
      });
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    } finally {
      this.isModalLoading = false;
    }
  }

  async navigateToStock() {
    await this.router.navigate(['/stock']);
    this.dataSubscription$.unsubscribe();
  }

  async openSidenav(type) {
    const data = { type: type, load: true };
    this.sidenavService.toggle(data).then(async (res: any) => {
      if (res) await this.update();
    });
  }

  async update() {
    try {
      this.isLoading = true;
      await this.exitService.reload(this.appliedFilters, this.sortParams);
      this.getTotalProductsCount();
      this.actualHour = moment().format('HH:mm');
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    } finally {
      this.isLoading = false;
    }
  }

  getTotalProductsCount() {
    this.cratesService.getProductsCount("EXIT", this.appliedFilters).then((res) => {
      this.totalProductsCount = res.allProducts.total;
    });
  }

  async getNextPage(){
    await this.exitService.getNextPage(this.appliedFilters, this.sortParams);
  }

  async getPreviousPage(){
    await this.exitService.getPreviousPage(this.appliedFilters, this.sortParams);
  }

  async onPageSizeChange(event: number){
    await this.exitService.setPageSize(event);
  }

  async onPageChange(event: number){
    await this.exitService.setPage(event, this.appliedFilters, this.sortParams);
  }

}
